var map = {
	"./Baskerville/Untitled-2-01.jpg": 3105,
	"./Baskerville/Untitled-2-03.jpg": 1011,
	"./Baskerville/Untitled-2-05.jpg": 7101,
	"./Baskerville/Untitled-2-06.jpg": 7874,
	"./Baskerville/Untitled-2-07.jpg": 9583,
	"./Baskerville/Untitled-2-08.jpg": 1836,
	"./Baskerville/Untitled-2-09.jpg": 8713,
	"./Baskerville/Untitled-2-10.jpg": 5203,
	"./Feira Vinho/hsh-02.jpg": 4274,
	"./Feira Vinho/hsh-03.jpg": 5983,
	"./Feira Vinho/hsh-04.jpg": 7700,
	"./Feira Vinho/post insta-01.jpg": 5049,
	"./Feira Vinho/post insta-02.jpg": 4782,
	"./Feira Vinho/post insta-03.jpg": 2827,
	"./Feira Vinho/post insta-04.jpg": 6088,
	"./Heinz/Heinz_ToDieFor_03Posters.jpg": 2302,
	"./Heinz/heinz.jpg": 539,
	"./Heinz/heinz2.jpg": 5473,
	"./Inesis/3 cartazes.jpg": 6680,
	"./Inesis/3 outdoors in 1.png": 42,
	"./Inesis/inesis.jpg": 2555,
	"./Inesis/inesis2.jpg": 5041,
	"./Inesis/inesis3.jpg": 644,
	"./Inesis/inesis4.jpg": 3375,
	"./Inesis/inesis5.jpg": 6994,
	"./Inesis/logo.png": 7547,
	"./MaeQueroSerArtista/Captura de ecrã 2025-12-05 215631.png": 3243,
	"./MaeQueroSerArtista/mae quero ser.jpg.png": 4330,
	"./MaeQueroSerArtista/mae quero ser2.jpg.png": 804,
	"./Pyreenes/2-08.jpg": 4983,
	"./Pyreenes/AugustaSilva_40220223_9-ezgif.com-video-to-gif-converter.gif": 4947,
	"./Pyreenes/ezgif.com-video-to-gif-converter (2).gif": 6170,
	"./Pyreenes/ezgif.com-video-to-gif-converter.gif": 3341,
	"./Pyreenes/ilustração-13.jpg": 7730,
	"./Pyreenes/padrão 2.jpg.png": 3468,
	"./TimeOut/1-01.jpg": 2235,
	"./TimeOut/2-01.jpg": 366,
	"./TimeOut/4-01.jpg": 7160,
	"./TimeOut/8.1-ezgif.com-video-to-gif-converter.gif": 8397,
	"./TimeOut/Untitled-1-01-01.jpg": 5493,
	"./TimeOut/WhatsApp Image 2026-03-05 at 15.26.00 (1).jpeg": 7129,
	"./TimeOut/WhatsApp Image 2026-03-05 at 15.26.00 (2).jpeg": 3774,
	"./TimeOut/WhatsApp Image 2026-03-05 at 15.26.00.jpeg": 3603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5937;